const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export function openPrintWindow(html) {
  const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
  const w = window.open(url, "_blank");
  if (!w) { URL.revokeObjectURL(url); return false; }
  w.addEventListener("load", () => setTimeout(() => URL.revokeObjectURL(url), 60000), { once: true });
  return true;
}

export const printHtml = (title, body, css) => `<!doctype html><html><head><meta charset="utf-8"><title>${esc(title)}</title><style>${css}</style></head><body>${body}<script>window.onload=function(){window.print();}</script></body></html>`;
export { esc };
